import { APP_VERSION } from '../config/appVersion';

const SW_URL = '/sw.js';
const LEGACY_SW_CLEARED_KEY = 'sa_legacy_sw_cleared_v1';

/** Limpa storage e recarrega quando a versão do app mudou (bundle novo). */
export function runVersionEnforcer() {
  if (typeof window === 'undefined') return true;

  try {
    const stored = localStorage.getItem('app_version');
    if (stored === APP_VERSION) return true;

    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem('app_version', APP_VERSION);

    // Mantém flag de limpeza de SW legado e pede limpeza de caches do SW ativo
    localStorage.setItem(LEGACY_SW_CLEARED_KEY, '1');
    void clearServiceWorkerCaches();

    if (stored != null) {
      const url = new URL(window.location.href);
      if (url.searchParams.get('_appv') !== APP_VERSION) {
        url.searchParams.set('_appv', APP_VERSION);
        window.location.replace(url.toString());
        return false;
      }
    }
    return true;
  } catch {
    return true;
  }
}

/** Remove SWs legados uma vez (antes do SW oficial do PWA). */
export async function clearLegacyServiceWorkersOnce() {
  if (!('serviceWorker' in navigator)) return;
  try {
    if (localStorage.getItem(LEGACY_SW_CLEARED_KEY) === '1') return;
    const registrations = await navigator.serviceWorker.getRegistrations();
    const legacy = registrations.filter((reg) => {
      const scriptURL = reg.active?.scriptURL || reg.installing?.scriptURL || reg.waiting?.scriptURL || '';
      return scriptURL && !scriptURL.endsWith('/sw.js');
    });
    await Promise.all(legacy.map((reg) => reg.unregister()));
    localStorage.setItem(LEGACY_SW_CLEARED_KEY, '1');
  } catch {
    /* ignore */
  }
}

/** Pede ao SW ativo para limpar caches (evita bundle velho após deploy). */
export async function clearServiceWorkerCaches() {
  if (!('serviceWorker' in navigator)) return;
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(
      registrations.map(async (reg) => {
        const worker = reg.active || reg.waiting || reg.installing;
        if (worker) {
          worker.postMessage({ type: 'CLEAR_CACHES' });
          worker.postMessage({ type: 'SKIP_WAITING' });
        }
      }),
    );
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.filter((k) => k.startsWith('sa-pwa-')).map((k) => caches.delete(k)));
    }
  } catch {
    /* ignore */
  }
}

/** Registra o service worker do PWA e aplica updates com skipWaiting. */
export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return null;
  if (process.env.NODE_ENV !== 'production') return null;

  try {
    await clearLegacyServiceWorkersOnce();
    const registration = await navigator.serviceWorker.register(SW_URL, { scope: '/' });

    registration.addEventListener('updatefound', () => {
      const installing = registration.installing;
      if (!installing) return;
      installing.addEventListener('statechange', () => {
        if (installing.state === 'installed' && navigator.serviceWorker.controller) {
          installing.postMessage({ type: 'SKIP_WAITING' });
        }
      });
    });

    // Se já houver waiting, ativa imediatamente
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }

    return registration;
  } catch (err) {
    console.warn('Falha ao registrar service worker:', err);
    return null;
  }
}
